import { render } from "./VideoDetailsBookmarkButton.vue?vue&type=template&id=efcc3f3c&ts=true"
import script from "./VideoDetailsBookmarkButton.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsBookmarkButton.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__